import RemoteService from './../../sections/servicesSections/RemoteService';
import Breadcrumb from './../../components/BreadCrumb';
import HeadingDetailsSection from './../../sections/HeadingDetailsSection';

function RemoveServiceScreen() {
  return (
    <>
        <HeadingDetailsSection heading='Remote In-House Counsel'>
          <Breadcrumb parent="Services" screen='Remote In-House Counsel'/>
        </HeadingDetailsSection>
        <RemoteService/>
    </>
  );
}

export default RemoveServiceScreen;
